import { sendGTMEvent } from "@next/third-parties/google";
import { useEffect } from "react";

export const sendEvent = (event: string, options: object = {}) => {
	sendGTMEvent({ event, ...options });
};

export const sendSignUpEvent = () => {
	sendEvent("sign_up", {
		referrer: document.referrer,
		sign_up_method: "email",
	});
};

export const sendPageViewEvent = (location: string) => {
	sendEvent("page_view", {
		page_path: location,
		page_title: document.title,
		referrer: document.referrer,
	});
};

export function useSendCurrentPageViewEvent() {
	useEffect(() => {
		sendPageViewEvent(window.location.pathname);
	}, []);
}

export const sendLandingPageViewEvent = () => {
	sendEvent("landing_page_view", {
		page_path: window.location.pathname,
		page_title: document.title,
		referrer: document.referrer,
	});
};

export const sendPricingPageViewEvent = () => {
	sendEvent("pricing_page_view", {
		page_path: window.location.pathname,
		page_title: document.title,
		referrer: document.referrer,
	});
};

export const sendSignUpPageViewEvent = () => {
	sendEvent("signup_page_view", {
		page_path: window.location.pathname,
		page_title: document.title,
		referrer: document.referrer,
	});
};

export const sendFranchiseLandingPageViewEvent = () => {
	sendEvent("landing_page_view", {
		icp: "franchise",
		page_path: window.location.pathname,
		page_title: document.title,
		referrer: document.referrer,
	});
};

export const sendFranchiseContactFormSubmitEvent = () => {
	sendEvent("sign_up", {
		sign_up_method: "franchise",
		page_path: window.location.pathname,
		page_title: document.title,
		referrer: document.referrer,
	});
};

export const useSendSignInPageViewEvent = () => {
	useEffect(() => {
		sendEvent("signin_page_view", {
			page_path: window.location.pathname,
			page_title: document.title,
			referrer: document.referrer,
		});
	}, []);
};

export const sendSignInEvent = (email: string) => {
	sendEvent("sign_in", {
		email,
	});
};
